import * as Form from '../../Form';
import { EditorsChoiceSectionBase } from '../../dapp-form/sections/EditorsChoiceSectionBase';
import type {
  FormState,
  NewDappInputChangeEvent,
  SingleFileFieldName,
} from '../types';

interface EditorsChoiceSectionProps {
  formData: FormState;
  onInputChange: (event: NewDappInputChangeEvent) => void;
  onSingleFileChange: (
    fieldName: SingleFileFieldName,
    file: File | null,
  ) => void;
}

export function EditorsChoiceSection({
  formData,
  onInputChange,
  onSingleFileChange,
}: EditorsChoiceSectionProps) {
  return (
    <EditorsChoiceSectionBase
      headline={formData.editorsChoiceHeadline}
      onInputChange={onInputChange}
      graphicField={
        <Form.ImageUploadInput
          name="editorsChoiceGraphic"
          label="Graphic"
          description="To visually represent the dApp"
          dimensions="1200x1200px"
          value={formData.editorsChoiceGraphic}
          onChange={(file: File | null) =>
            onSingleFileChange('editorsChoiceGraphic', file)
          }
          buttonType="add"
          buttonClassName="text-white"
          placeholderClassName="w-64 h-64"
        />
      }
    />
  );
}
